export const smartProcessTitlesMatchData = {
    'LEAD': 'lead',
    'CONTACT': 'contact',
    'COMPANY': 'company',
    'ORDER': 'order',
    'DEAL': 'deal',
    'QUOTE': 'quote',
    'INVOICE': 'invoice',
    'SMART_INVOICE': 'invoice',
    'REQUISITE': 'requisite',
};